var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeLayout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.32609 14.4131H1.36957C0.889318 14.4131 0.5 14.8024 0.5 15.2827V19.6305C0.5 20.1107 0.889318 20.5 1.36957 20.5H8.32609C8.80633 20.5 9.19565 20.1107 9.19565 19.6305V15.2827C9.19565 14.8024 8.80633 14.4131 8.32609 14.4131Z",
    stroke: "#fff",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6739 20.5H19.6304C20.1107 20.5 20.5 20.1107 20.5 19.6304V10.0652C20.5 9.58497 20.1107 9.19565 19.6304 9.19565L12.6739 9.19565C12.1937 9.19565 11.8043 9.58497 11.8043 10.0652L11.8043 19.6304C11.8043 20.1107 12.1937 20.5 12.6739 20.5Z",
    stroke: "#fff",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6739 6.58691L19.6304 6.58691C20.1107 6.58691 20.5 6.1976 20.5 5.71735V1.36952C20.5 0.889276 20.1107 0.499958 19.6304 0.499958L12.6739 0.499958C12.1937 0.499958 11.8043 0.889276 11.8043 1.36952V5.71735C11.8043 6.1976 12.1937 6.58691 12.6739 6.58691Z",
    stroke: "#fff",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32609 0.5H1.36957C0.889318 0.5 0.5 0.889318 0.5 1.36957V10.9348C0.5 11.415 0.889318 11.8043 1.36957 11.8043H8.32609C8.80633 11.8043 9.19565 11.415 9.19565 10.9348V1.36957C9.19565 0.889318 8.80633 0.5 8.32609 0.5Z",
    stroke: "#fff",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLayout);
export default __webpack_public_path__ + "static/media/changeLayout.48d2e345.svg";
export { ForwardRef as ReactComponent };